var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainWrapper", attrs: { id: "top" } },
    [
      _c("head-nav", { attrs: { gray: _vm.gray, pos: "fixed" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "innerWrapper" },
        [
          _c("h1", [_vm._v("Recommended service providers")]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(
              "\n      Here is a list of our preferred partners. Please use the code word\n      'UNIFI' when making your booking.\n    "
            )
          ]),
          _vm._v(" "),
          _vm.list.length == 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "padding-top": "80px",
                    "text-align": "center",
                    "font-size": "18px",
                    color: "#3F3F46",
                    "margin-bottom": "218px"
                  }
                },
                [_vm._v("\n      No data.\n    ")]
              )
            : _vm._l(_vm.list, function(item, index) {
                return _c("div", { key: index }, [
                  _c("h3", [_vm._v(_vm._s(item.type))]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(item.houseProvidersPojoList, function(img, i) {
                      return _c("li", { key: i }, [
                        _c("a", {
                          staticClass: "img",
                          style: {
                            backgroundImage: "url(" + img.logoUrl + ")"
                          },
                          attrs: { href: img.url, target: "_blank" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tag" }, [
                          _vm._v(_vm._s(img.tags))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              })
        ],
        2
      ),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47b6630c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b6630c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/recommend.vue
// module id = null
// module chunks = 